/* tslint:disable */
/* eslint-disable */
/**
 * Localingos API
 * Developer-first automated localization platform powered by AI. Sync your project and continuously localize only what changed.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ProjectDto } from './project-dto';

/**
 * 
 * @export
 * @interface ProjectWithUserAuthorization
 */
export interface ProjectWithUserAuthorization {
    /**
     * 
     * @type {ProjectDto}
     * @memberof ProjectWithUserAuthorization
     */
    'project': ProjectDto;
    /**
     * 
     * @type {string}
     * @memberof ProjectWithUserAuthorization
     */
    'userAuthorization': ProjectWithUserAuthorizationUserAuthorizationEnum;
}

export const ProjectWithUserAuthorizationUserAuthorizationEnum = {
    Admin: 'ADMIN',
    Read: 'READ',
    Write: 'WRITE',
    ReadWrite: 'READ_WRITE'
} as const;

export type ProjectWithUserAuthorizationUserAuthorizationEnum = typeof ProjectWithUserAuthorizationUserAuthorizationEnum[keyof typeof ProjectWithUserAuthorizationUserAuthorizationEnum];


